import { apiClient } from "lib/apiClient";
import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";

export interface IBasePlan {
  enabled: boolean;
  maxProperties: number;
  maxRowsPerScope: number;
}

export interface IProPlan extends IBasePlan {
  maxProperties: number;
  maxRowsPerScope: number;
}

export interface ITeamPlan extends IBasePlan {
  maxProperties: number;
  maxRowsPerScope: number;
}

export interface IPlans {
  basic: IBasePlan;
  pro: IProPlan;
  team: ITeamPlan;
}

export interface IAssistantPage {
  workflowId: string;
  workflowVersion: string;
  code: assistantPageCodeEnum;
  limits: IPlans;
}

export type TAssistantPages = IAssistantPage[];

export const getAssistantPages = async (): Promise<TAssistantPages> => {
  const response = await apiClient.get(`/assistant/pages`);

  return response.data;
};
